'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default ['$rootScope', '$scope', 'UserService', 'SettingsService',
                function($rootScope, $scope, UserService, SettingsService) {
                    $scope.ok = ok;
                    $scope.equalsPasswords = equalsPasswords;

                    // инициализация
                    init();

                    // region Function

                    function init() {
                        $rootScope.title = 'Настройка аккаунта';

                        $scope.user = null;
                        $scope.invalidPassword = false;
                        $scope.changePassword = {};

                        $scope.availableValuesByType = [];
                        $scope.currentValue = {};

                        UserService.api.me(null, (data) => {
                            $scope.user = data._embedded;
                        });

                        SettingsService.getAvailableValuesByType(SettingsService.PROJECT_SUPPORT_STAGE_DEFAULT_FILTER)
                                       .then((values) => {
                                           $scope.availableValuesByType = values;

                                           SettingsService.getValueByType(SettingsService.PROJECT_SUPPORT_STAGE_DEFAULT_FILTER)
                                                          .then((value) => {
                                                              $scope.currentValue = $scope.availableValuesByType
                                                                                          .find((_it) => _it.name === value);
                                                          });
                                       });
                    }

                    function ok() {
                        UserService.api.changePassword(null, {form: $scope.changePassword}, (data) => {
                            $scope.form_change_password.$setPristine();
                            $scope.invalidPassword = false;
                        }, (error) => {
                            $scope.invalidPassword = true;
                        });
                    }

                    function equalsPasswords() {
                        return angular.equals($scope.changePassword.repeatPassword, $scope.changePassword.newPassword);
                    }

                    $scope.onSelectSupportStage = () => {
                        SettingsService.setValueForType(SettingsService.PROJECT_SUPPORT_STAGE_DEFAULT_FILTER, $scope.currentValue.name);
                    };

                    // endregion
                }];
